import React, { useMemo } from 'react'
import injectStyles from 'react-jss'
import { StatusLabel } from '../../../../../../Components/StatusLabel'
import SimpleTableTable from '../../../../../../Components/SimpleTableTable'
import { LinkEdit } from '../../../../../../Components/Link/Edit'
import { ButtonDeleteInline } from '../../../../../../Components/Buttons/ButtonDeleteInline'
import { styles } from './style'
import { getActivityTableData, TableHeader } from './utils'

const ActivityTable = ({ spyActivities, deleteMission, ...props }) => {
  const data = useMemo(() => getActivityTableData(spyActivities), [
    spyActivities,
  ])

  const editMissionLink = mission => `/dashboard/mission/${mission.id}/edit`

  const postRowRender = spyActivity => {
    return {
      ...spyActivity,
      'STATUS': (
        <StatusLabel status={spyActivity.STATUS}>
          {spyActivity.STATUS}
        </StatusLabel>
      ),
      'ACTIONS': (
        <div className={props.classes.actions}>
          <LinkEdit to={editMissionLink(spyActivity)} />
          <ButtonDeleteInline
            onClickHandler={() => deleteMission(spyActivity)}
          />
        </div>
      ),
    }
  }

  return (
    <div className={props.classes.wrapper}>
      <SimpleTableTable
        header={TableHeader}
        data={data}
        postRowRender={postRowRender}
        showPages={false}
      />
    </div>
  )
}

export default injectStyles(styles)(ActivityTable)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/ActivityTable/ActivityTable.js